import axios from 'axios'
import {useMutation} from 'react-query'
import errorNotify from '../api/utils/errorNotify'

interface Args {
  latitude?: number
  longitude?: number
}

export default function useGetReverseGeocodingMapBox(
  errMsg = 'Could not retrieve latitude and longitude for businss address'
) {
  return useMutation(async (args: Args) => {
    try {
      const latitude = args?.latitude ?? ''
      const longitude = args?.longitude ?? ''
      const route = `https://api.mapbox.com/geocoding/v5/mapbox.places/
        ${`${longitude},${latitude}`}.json?language=en&access_token=${
        process.env.REACT_APP_MAPBOX_TOKEN
      }`
      const res = await axios.get(route)
      return res.data?.features
    } catch (err) {
      errorNotify(err, errMsg)
    }
  })
}
